"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _gidb = _interopRequireDefault(require("./gidb"));
var db = '';
var initDB = function initDB() {
  if (db) return db;
  db = new _gidb.default({
    databaseName: 'ZZ_LEGO_DATAS',
    version: 1
  });
  db.createStore('baseInfo', {
    keyPath: 'id',
    autoIncrement: true
  });
  db.createStore('logs', {
    keyPath: 'id',
    autoIncrement: true
  });
  db.createStore('events', {
    keyPath: 'id',
    autoIncrement: true
  });
  db.createStore('failEvents', {
    keyPath: 'id',
    autoIncrement: true
  });
  // db.version(1).stores({
  //   baseInfo: "++id, time, data",
  //   logs: "++id, *type, time, data",
  //   events: "++id, *actiontype, *pagetype, time, data, status, msg",
  //   failEvents: "++id, code, time, data, retryNum"
  // })
  return db;
};
var _default = exports.default = initDB;